import * as React from 'react'


import GeneralAccounts from './GeneralAccounts'


interface AccountingProps { }

const Accounting : React.FunctionComponent<AccountingProps> = ({}) => {
    const [ activeTab, setactiveTab ] = React.useState('generalAccounts')

    return (
        <div style={{ display: 'grid', gridTemplateColumns: '200px 3fr', height: '100vh' }}>
            <div className='light-orangex' style={{ backgroundColor: '#B2ACA7', color: 'white', fontWeight: 'bold' }}>
                <h2>Accounting</h2>
                <div>
                    <a href='#' className='white-link' onClick={() => { setactiveTab('generalAccounts') }}>
                        <p>General Accounts</p>
                    </a>
                </div>
                <div>
                    <a href='#' className='white-link' onClick={() => { setactiveTab('chartOfAccounts') }}>
                        <p>Chart of Accounts</p>
                    </a>
                </div>
            </div>
            <div>
                {activeTab == 'generalAccounts' && <GeneralAccounts />}
                <br /><br /><br />
            </div>
        </div>
    )
}

export default Accounting